import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAddKeyframe: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="add-keyframe, rhombus"><path d="M12 2.25L2.25 12L12 21.75L21.75 12L12 2.25Z" stroke="currentColor" strokeWidth="1.5"/><path d="M12 9V15M9 12H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconAddKeyframe;
